import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Rentals',
		url: '/rentals',
		icon: 'tags',
	},
];

export default class Rentals extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalRental')} size="sm" color="primary">
						<i className="fa fa-tags"/>&nbsp;&nbsp;Add Rental
					</Button>
				</Framework.Components.PageBar>

				<Collections.Rentals
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					scannedCode={!this.state['modalRental'] ? this.props.scannedCode : null}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Rental"}
					object={Objects.Rental}
					history={this.props.history}
					toggle={this.state['modalRental']}
					reportClose={this.reportClose('modalRental')}
					afterSave={this.handleAfterSave}
					objectProps={{scannedCode: this.state['modalRental'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}

